import { Head, usePage } from "@inertiajs/react"

const CATEGORY_LABELS: Record<string, string> = {
  forum: "Foro",
  event: "Eventos",
  order: "Pedidos",
  raffle: "Sorteos",
  system: "Sistema",
  chat: "Chat",
}

interface PageProps {
  action: string
  masked_email: string
  category?: string
  [key: string]: unknown
}

export default function UnsubscribeShow() {
  const {
    action,
    masked_email: maskedEmail,
    category,
  } = usePage<PageProps>().props

  const isAll = action === "all"
  const categoryLabel = category ? CATEGORY_LABELS[category] || category : ""

  return (
    <>
      <Head title="Desuscripción confirmada" />
      <div className="bg-background flex min-h-screen items-center justify-center p-4">
        <div className="bg-card w-full max-w-md rounded-xl p-8 shadow-md">
          <div className="mb-6 text-center">
            <span className="text-4xl">&#x2705;</span>
          </div>
          <h1 className="text-foreground mb-2 text-center text-xl font-bold">
            Desuscripción confirmada
          </h1>
          <p className="mb-4 text-center text-sm text-[#4a4a68]">
            {isAll ? (
              <>
                Se desactivaron <strong>todos los emails</strong> de
                notificaciones para <strong>{maskedEmail}</strong>.
              </>
            ) : (
              <>
                Se desactivaron los emails de <strong>{categoryLabel}</strong>{" "}
                para <strong>{maskedEmail}</strong>.
              </>
            )}
          </p>
          <p className="text-center text-xs text-[#8888a0]">
            Podés cambiar tus preferencias de notificación desde tu cuenta en
            cualquier momento.
          </p>
        </div>
      </div>
    </>
  )
}
